import type { NavigateFunction } from 'react-router-dom';
import { SecondarySidebar, SecondarySidebarSection, type AppLayoutApi } from '@jordan/ui';
import { BILLING_TIME_NAV } from './billingTimeNav';

/**
 * Shared secondary (left) sidebar for the Consulting → Billing & Time dashboard — the same
 * Track / Analyze / Manage navigation on every page. `pathname` decides the active item.
 */
export function billingTimeSidebar(navigate: NavigateFunction, pathname: string) {
  return function BillingTimeSecondarySidebar(api: AppLayoutApi) {
    const go = (path: string) => {
      navigate(path);
      api.closeSecondarySidebar();
    };
    return (
      <SecondarySidebar
        title="Billing & Time"
        mobileExpanded={api.secondarySidebarExpanded}
        onClose={api.closeSecondarySidebar}
      >
        {BILLING_TIME_NAV.map((section) => (
          <SecondarySidebarSection key={section.title} title={section.title} flush>
            <ul className="nav nav-sidebar my-2" data-nav-type="accordion">
              {section.items.map((it) => (
                <li className="nav-item" key={it.path}>
                  <a
                    href={it.path}
                    className={`nav-link ${pathname === it.path ? 'active' : ''}`.trim()}
                    onClick={(e) => {
                      e.preventDefault();
                      go(it.path);
                    }}
                  >
                    <i className={`${it.icon} me-3`} />
                    {it.label}
                  </a>
                </li>
              ))}
            </ul>
          </SecondarySidebarSection>
        ))}
      </SecondarySidebar>
    );
  };
}
